/* eslint-disable no-tabs */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { setIsMarketingModalShowing } from '../../ducks/sportsScienceActions';
import MarketingModal from './MarketingModal';

const MarketingModalOverlay = styled('div')`
  height: 100vh;
  width: 100vw;
  position: absolute;
  background-color: rgba(216, 216, 216, 0.8);
  z-index: 1002;
  pointer-events: ${(props) => (props.isActive ? 'auto' : 'none')};
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.isActive ? 0.5 : 0)};
`;

const MarketingModalContainer = () => {
  const dispatch = useDispatch();
  const isMarketingModalShowing = useSelector(
    (state) => state.sportsScience.data.isMarketingModalShowing,
  );

  return (
    <>
      <MarketingModal />
      <MarketingModalOverlay
        isActive={isMarketingModalShowing}
        onClick={
          () => dispatch(setIsMarketingModalShowing(false))
          }
      />
    </>
  );
};

MarketingModalContainer.propTypes = { };

export default MarketingModalContainer;
